import * as React from "react";
const SvgDotLine = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 58 2",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeDasharray: "2 2",
	strokeWidth: 2,
	d: "M.521 1h57.054"
}));
export default SvgDotLine;
